import { Card, Flex, Row } from 'antd';
import React from 'react';
import place1 from "../../assets/images/website/aboutus/place1.jpeg";
import place2 from "../../assets/images/website/aboutus/place2.jpeg";
import place3 from "../../assets/images/website/aboutus/place3.jpeg";
import place4 from "../../assets/images/website/aboutus/place4.jpeg";
import paytan1 from "../../assets/images/website/aboutus/paytan1.jpeg";
import paytan2 from "../../assets/images/website/aboutus/paytan2.jpeg";
import paytan3 from "../../assets/images/website/aboutus/paytan3.jpeg";
import kagalmap from "../../assets/images/website/aboutus/kagalmap.png";
import "./about-us.css"

const AboutUs = () => {
    return (
        <Card title={<h2>पंचायत समिती विषयी</h2>}>
            <h4>
                दीनदुबळ्या रयतेसाठी अहोरात्र राबणारा लोकराजा राजर्षी छ.शाहू महाराज यांचं जनक घराण म्हणजे कागल.
                कागल तालुका हा अनेक ऐतिहासिक, धार्मिक व भौगोलिक विविधतेने नटलेला आहे. कागल तालुक्याचे भौगोलिक क्षेत्रफळ हे 77.38 चौरस किलोमीटर इतके 
                असून ग्रामीण भागातील लोकसंख्या 2,75,872 इतकी आहे.
            </h4>
            <h4>
                तालुक्यात अनेक धार्मिक स्थळे आहेत. दूधगंगा, वेदगंगा आणि चिकोत्रा नद्यांच्या काठावर वसलेल्या
                या कागल तालुक्यामध्ये श्री गहिनीनाथ गैबी पीर, श्री. राम मंदिर, मेतके येथील संत बाळूमामा मंदिर,
                कुरुकली येथील घोडेकर मंदिर प्रसिद्ध आहेत.
            </h4>

            <Row justify='space-around' gutter={[8, 8]}>
                <img src={place1} style={{ height: 185, width: 225 }} />
                <img src={place2} style={{ height: 185, width: 225 }} />
                <img src={place3} style={{ height: 185, width: 225 }} />
                <img src={place4} style={{ height: 185, width: 225 }} />
            </Row>
            <h4>
                त्याचप्रमाणे कागल तालुका हा कुस्तीगिरांचा, सैनिकांचा, प्रगतशिल शेतकऱ्यांचा म्हणून ओळखला जातो.
                कोल्हापुरी पायतानातील "कापशी सेनापती" हा प्रकार कागल तालुक्यातीलच. तालुक्यातील सेनापती कापशी हे गाव या बांधणीच्या पायतानासाठी सुप्रसिद्ध आहे.
            </h4>
            <Row justify='space-around' gutter={[8, 8]}>
                <img src={paytan1} style={{ height: 185, width: 275 }} />
                <img src={paytan2} style={{ height: 185, width: 275 }} />
                <img src={paytan3} style={{ height: 185, width: 275 }} />
            </Row>
            <h4>
                ग्रामीण भागात 83 गावांमध्ये विभागलेला कागल तालुक्याचे विकासात्मक कामकाज पंचायत समिती कागलच्या माध्यमातून केले जाते.
            </h4>
            <Row justify='space-around' gutter={[8, 8]}>
                <img src={kagalmap} style={{ width: "100%" }} />
            </Row>
            <h4>
                शासनाच्या सर्व योजना चांगल्याप्रकारे राबवण्यात कागल पंचायत समिती ही नेहमीच अग्रेसर राहिलेली आहे.
                या काही वर्षात पंचायत समिती उत्कृष्ट कामगिरी करत जिल्हा व राज्य पातळीवर यश संपादित केले आहे.
            </h4>
            <table >
                <tr>
                    <th>अ.क्र.</th>
                    <th>योजनेचे नाव</th>
                    <th>स्तर</th>
                    <th>क्रमांक</th>
                    <th>वर्ष</th>
                </tr>
                <tr>
                    <td>१.</td>
                    <td>यशवंत पंचायत राज</td>
                    <td>विभागीय</td>
                    <td>प्रथम</td>
                    <td>२०२१</td>
                </tr>
                <tr>
                    <td>२.</td>
                    <td>यशवंत पंचायत राज</td>
                    <td>राज्य</td>
                    <td>द्वितीय</td>
                    <td>२०२१</td>
                </tr>
                <tr>
                    <td>३.</td>
                    <td>आदर्श महिला-स्नेही पंचायत</td>
                    <td>राष्ट्रीय</td>
                    <td>तृतीय</td>
                    <td>२०२३</td>
                </tr>
            </table>
            <h4>
                अशाप्रकारे कागल पंचायत समितीच्या माध्यमातून
                लोकहिताची व विकासात्मक कामे राबविण्यात येत आहेत. याचीच
                माहिती नागरीकांपर्यंत पोहोचावी यासाठीच या संकेतस्थळाचा
                प्रयत्न राहणार आहे. त्याचप्रमाणे या संकेतस्थळाच्या माध्यमातून प्राप्त होणाऱ्या 
                जनतेच्या सूचना, अभिप्राय व मार्गदर्शन निश्चीतच पंचायत
                समितीच्या प्रगतीसाठी प्रेरणादायी ठरेल. या संकेतस्थळाचा नागरीकांना
                निश्चितच लाभ होईल अशी आम्ही अपेक्षा बाळगतो.
            </h4>
            <h3>
                धन्यवाद..!!
                पंचायत समिती कागल.
            </h3>
        </Card>
    );
}

export default AboutUs;